/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import { customStyle } from 'helper';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';
import AreaChartComponent from '../components/AreaChartComponent';

import * as actions from '../actions';
import * as c from '../constants';

const colors = ['#5272AA', '#7790CB', '#8AA4F8', '#A3B3F9'];

const optionList = [
  { label: 'INDIVIDUAL', value: 'INDIVIDUAL' },
  { label: 'CORPORATION', value: 'CORPORATION' },
];


const payload = {
  period: 'MONTHLY',
  date_from: moment().startOf('year').format('YYYY-MM-DD'),
  date_to: moment().endOf('year').format('YYYY-MM-DD'),
};

const rename = (obj, oldKey, newKey) => {
  if (_.has(obj, oldKey)) {
    _.set(obj, newKey, _.get(obj, oldKey));
    _.unset(obj, oldKey);
  }
  return obj;
};

const filter = {
  transaction_type: 'ALL',
};

function EbillsDashboardContainer({
  graphStats,
  getGraphStats,
}) {
  const [filterData, setFilterData] = useState(filter);
  const [isLoading, setIsLoading] = useState(true);

  // added fro billsPaymentDashboard
  const formatData = (data) => {
    if (!data) return [];
    return Object.keys(data).map((val) => {
      return { name: val, value: data[val] };
    });
  };

  const renderLegends = (dt) =>
    dt.map((x) => {
      return (
        <div key={x.name} className="legend-item">
          <div
            style={{
              background: `${x.color}`,
              width: 20,
              height: 20,
              marginRight: 20,
            }}
          />
          <div className="legend-text">{x.name}</div>
        </div>
      );
    });
  // added for billsPaymentDashboard

  // const handleOnSubmit = (data) => {
  //   getGraphStats({
  //     ...data,
  //     module_type: 'T_BPLS',
  //     permit_type: 'Business Permit Application (NEW & RENEWAL)',
  //   });
  // };

  const handleOnSubmit = (data) => {
    getGraphStats(data);
  };

  const handleChangeSelect = (e) => {
    setFilterData({
      ...filterData,
      transaction_type: e ? e.value : '',
    });
  };

  const formatKey = [
    {
      key: 'INDIVIDUAL',
      color: `${colors[0]}`,
    },
    {
      key: 'CORPORATION',
      color: `${colors[1]}`,
    },
  ];

  useEffect(() => {
    getGraphStats(payload);
    setIsLoading(false);
    return () => {
      setIsLoading(false);
    };
  }, []);

  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="text-bold">Sales and Transactions</div>
        </div>
        <div className="col-12">
          <SelectDateFilter onSubmit={handleOnSubmit} />
        </div>
        <div className="col-12">
          <AreaChartComponent
            chartData={graphStats}
          />
        </div>
        {/* <div className="legends-wrapper area px-3 w-100">
          <div
            className="render-chart-legends"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            {renderLegends(c.E_BILLS)}
          </div>
        </div> */}
      </div>
    </div>
  );
}

EbillsDashboardContainer.propTypes = {
  graphStats: PropTypes.instanceOf(Array).isRequired,
  getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

// const formatGraphData = (data) => {
//   const labels = [];
//   const values = [];

//   data.forEach((item, i) => {
//     const entries = Object.entries(item).filter(
//       (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
//     );

//     if (i === 0) {
//       entries.forEach((entry, x) => {
//         labels[x] = {
//           key: entry[0],
//           color: colors[x],
//         };
//       });
//     }

//     values[i] = rename(
//       rename(
//         rename(item, 'OHP', 'Occupational / Health Permits'),
//         'CDL',
//         'Community Tax CertificateCTC / CEDULA'
//       ),
//       'PSA',
//       'Civil Registry Office'
//     );
//   });

//   return {
//     labels,
//     values,
//   };
// };

const mapStateToProps = ({ api }) => ({
  graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(EbillsDashboardContainer);
